import {dateFormatter, numberFormatter, percentageBarFormatter} from "../../gridFormatters";

export const colDateDef = [
	{
		"field": "collection_date",
		"sort": "desc",
		"headerName": "Collection Date",
		"cellRenderer": dateFormatter
	}
];

export const allCapacityTrendDefs = [
	{
		"field": "allocated",
		"type": "numericColumn",
		"headerName": "Allocated",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "used",
		"type": "numericColumn",
		"headerName": "Used",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "snap",
		"type": "numericColumn",
        "filter": "agNumberColumnFilter",
		"headerName": "Snap",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "free",
		"type": "numericColumn",
		"headerName": "Free",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "capacity",
		"type": "numericColumn",
		"headerName": "Capacity",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "orphaned",
		"type": "numericColumn",
		"headerName": "Orphaned",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	}
];

export const allBusinessUnitsTrendDefs = [
	{
		"field": "allocated",
		"type": "numericColumn",
		"headerName": "Allocated",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "used",
		"type": "numericColumn",
		"headerName": "Used",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "free",
		"type": "numericColumn",
		"headerName": "Free",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "percent_used",
		"type": "numericColumn",
		"headerName": "% Used",
		"filter": "agNumberColumnFilter",
		"cellRenderer": percentageBarFormatter,
	}
];
export const allPhysCapacityTrendDefs = [
	{
		"field": "allocated",
		"type": "numericColumn",
		"headerName": "Allocated",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "physical_used",
		"type": "numericColumn",
		"headerName": "Physical Used",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "snap",
		"type": "numericColumn",
		"headerName": "Snap",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "physical_free",
		"type": "numericColumn",
		"headerName": "Physical Free",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "physical_capacity",
		"type": "numericColumn",
		"headerName": "Physical Capacity",
        "filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "orphaned",
		"type": "numericColumn",
		"headerName": "Orphaned",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	}
];

export const allCapacityByDataCenterTrendDefs = [
	{
		"field": "data_center",
		"headerName": "Data Center",
		// "enableRowGroup": true
	},
	{
		"field": "growth_rate",
		"type": "numericColumn",
		"headerName": "Growth Rate",
		"filter": "agNumberColumnFilter",
		"hide": true
	}
];

export const allCapacityByDeviceTypeTrendDefs = [
	{
		"field": "device_type_code",
		"headerName": "Device Type Code",
		"enableRowGroup": true
	}
];

export const allCapacityByCompanyTrendDefs = [
	{
		"field": "company_name",
		"headerName": "Company",
		"enableRowGroup": true
	}
];

export const allCapacityByGeographyTrendDefs = [
	{
		"field": "geography",
		"headerName": "Geography",
		"enableRowGroup": true
	}
];

export const allCapacityByClassificationTrendDefs = [
	{
		"field": "classification",
		"headerName": "Classification",
		"enableRowGroup": true
	}
];
export const allCapacityByBusinessUnitTrendDefs = [
	{
		"field": "business_unit",
		"headerName": "Business Unit",
		"enableRowGroup": true
	}
];

export const allCapacityByApplicationTrendDefs = [
	{
		"field": "application",
		"headerName": "Application",
		"enableRowGroup": true
	}
];

// Performance

export const allPerformanceTrendDefs = [
	{
		"field": "iops",
		"type": "numericColumn",
		"headerName": "IOPS",
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"allowedAggFuncs": [
			"sum"
		],
		"cellRenderer": numberFormatter,
	},
	{
		"field": "latency",
		"type": "numericColumn",
		"headerName": "Latency",
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"allowedAggFuncs": [
			"sum"
		],
		"cellRenderer": numberFormatter,
	},
	{
		"field": "mbsec",
		"type": "numericColumn",
		"headerName": "MB/Sec",
		"filter": "agNumberColumnFilter",
		"aggFunc": "sum",
		"allowedAggFuncs": [
			"sum"
		],
		"cellRenderer": numberFormatter,
	}
];

// DRR

export const deviceTypeDRRDefs = [
    {
        "field": "device_type_description",
        "headerName": "Array Name"
    }
];

export const deviceDataReductionRatioDefs = [
    {
        "field": "DRR",
        "type": "numericColumn",
        "headerName": "Data Reduction Ratio",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter,
		"aggFunc": "avg"

    }
];
